import request from '@/util/request'

// 导入布局
export function importLayout (id, data) {
	return request({
		url: `/maintain-s/layout/${id}/import`,
		method: 'post',
		data
	})
}

// 导出布局
export function exportLayout (id, data) {
	return request({
		url: `/maintain-s/layout/${id}/export?systemId=${data.systemId}`,
		method: 'post',
		responseType: 'blob',
		data: data.field
	})
}

// 获取布局信息
export function apiGetLayout (id,systemId) {
	return request({
		url: `/maintain-s/layout/${id}/layoutItem?systemId=${systemId}`,
		method: 'get'
	})
}

// 保存布局信息
export function apiPostLayout (id,systemId,data) {
	return request({
		url: `/maintain-s/layout/${id}/layoutItem?systemId=${systemId}`,
		method: 'post',
		data
	})
}

//获取组件的时间点数据
export function apiGetTimeData(systemId,time,timeClass){
	let url=`/maintain-s/system/layout/${systemId}/stats/`;
	let params={};
	switch(timeClass){
		case "day":
			url+=`daily`;
			params.collectionTime=time;
			break;
		case "month":
			url+=`month`;
			params.collectionDay=time;
			break;
		case "year":
			url+=`year`;
			params.month=time.month;
			params.year=time.year;
			break;
		case "all":
			url+=`total`;
			params.year=time;
			break;
	}
	return request({
		url,
		method: 'get',
		params
	});
}

//保存系统布局
export function apiSaveLayout(){
}



// WEBPACK FOOTER //
// ./src/api/maintain/layout/index.js